{
  "header": "<h2>Please continue your booking with another payment method</h2>",
  "header-onboard-spend": "<h2>Unfortunately, we can't proceed with your application based on the information provided.</h2>",
  "header-ssn-failure": "<h2>We're sorry, but based on the info you provided, we cannot proceed with your application at this time.</h2>",
  "cannot-proceed": "<p>We are not able to proceed with your loan request. Please use another form of payment to complete your booking with your agent.</p>",
  "cannot-proceed-ssn-failure": "<p>Your application has not been submitted. Please check your email for a more in-depth explanation from our team and steps you can take to continue with your application.</p>",
  "click-here": "click here",
  "uplift": {
    "payLink": "https://pay.uplift.com",
    "additional-information": "<p>If you would like additional information about our decision on your application, <0/>. The information is also available in your account at <1>pay.uplift.com</1>.</p>",
    "questions": "<p>Questions? Please contact Uplift</p>"
  },
  "flexpay": {
    "payLink": "https://upgrade.com/pay",
    "additional-information": "<p>If you would like additional information about our decision on your application, <0/>. The information is also available in your account at <1>upgrade.com/pay</1>.</p>",
    "questions": "<p>Questions? Please contact us.</p>"
  }
}
